import { Create, SimpleForm, TextInput, SelectInput } from 'react-admin';
import { Box } from '@mui/material';
import { layout } from '../styles/ds';

const STATUS_CHOICES = [
  { id: 'new',       name: 'חדש' },
  { id: 'contacted', name: 'טופל' },
  { id: 'qualified', name: 'מתאים' },
  { id: 'closed',    name: 'סגור' },
];

const LeadCreate = () => (
  <Create title="ליד חדש">
    <SimpleForm>
      <Box sx={layout.formGrid}>
        <TextInput source="first_name" label="שם פרטי" fullWidth />
        <TextInput source="last_name"  label="שם משפחה" fullWidth />
        <TextInput source="phone" label="טלפון" fullWidth />
        <TextInput source="email" label="אימייל" fullWidth />
        <TextInput source="source" label="מקור" fullWidth />
        <SelectInput source="status" label="סטטוס" choices={STATUS_CHOICES} defaultValue="new" fullWidth />
      </Box>
      <TextInput source="notes" label="הערות" multiline rows={4} fullWidth />
    </SimpleForm>
  </Create>
);

export default LeadCreate;
